import React, { Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';

import AppHeader from '../Layout/AppHeader/';
import AppSidebar from '../Layout/AppSidebar/';
import AppFooter from '../Layout/AppFooter/';
import ThemeOptions from '../Layout/ThemeOptions/';
import { PrivateRoute } from '../Components/PrivateRoute';
import Logout from '../Views/Logout';
import { ToastContainer } from 'react-toastify';
import PartnerList from '../Views/Partner/PartnerList';
import UserList from '../Views/User/UserList';
import FullUserList from '../Views/User/FullUserList';
import UserSettings from '../Views/User/UserSettings/UserSettings';
import PartnerSettings from '../Views/Partner/PartnerSettings/PartnerSettings';
import DecisionTemplateSettings from '../Views/Decision/DecisionTemplateSettings';
import AlternativeSettings from '../Views/Alternative/AlternativeSettings';
import MetricSettings from '../Views/Metric/MetricSettings';
import CriteriaSettings from '../Views/Criteria/CriteriaSettings';
import ParticipantSettings from '../Views/Participant/ParticipantSettings';
import DecisionTemplateList from '../Views/Decision/DecisionTemplateList';
import Profile from '../Views/User/Profile';
import FullProfile from '../Views/User/FullProfile';
import FullProfileWithPaiment from '../Views/User/FullProfileWithPaiment';
import SystemAdmin from '../Views/SystemAdmin/SystemAdmin';
import DecisionTemplateResults from '../Views/Decision/DecisionTemplateResults';

// import { MuiPickersUtilsProvider } from '@material-ui/pickers';
// import MomentUtils from '@date-io/moment';
class Main extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            closeButtonRef: undefined
        }
        // this.closeButtonRef = undefined;
    }

    setStopButtonRef = (ref) => {
        //this.closeButtonRef = ref;
        this.setState({ closeButtonRef: ref });
    }

    render() {
        return (
            <Fragment>
                <ThemeOptions />
                <AppHeader closeButtonRef={this.state.closeButtonRef} />
                <div className="app-main">
                    <AppSidebar {...this.props} setStopButtonRef={this.setStopButtonRef} />
                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}> */}
                    <div className="app-main__outer">
                        <div className="app-main__inner">
                            <PrivateRoute exact path='/' component={PartnerList} />
                            <PrivateRoute exact path='/partners' component={PartnerList} />
                            <PrivateRoute exact path='/fullusers' component={FullUserList} />
                            <PrivateRoute exact path='/profile' component={Profile} />
                            <PrivateRoute exact path='/fullprofile/:userId' component={FullProfile} />
                            <Route exact path='/fullprofilepayment/:userId' component={FullProfileWithPaiment} />
                            <PrivateRoute exact path='/users/:partnerId' component={UserList} />
                            <PrivateRoute exact path='/usersettings/:partnerId/:userId' component={UserSettings} />
                            <PrivateRoute exact path='/partnersettings/:partnerId' component={PartnerSettings} />
                            <PrivateRoute path='/decisiontemplates/:partnerId' component={DecisionTemplateList} />
                            <PrivateRoute path='/decisiontemplate/:partnerId/:partnerScenarioId' component={DecisionTemplateSettings} />
                            <PrivateRoute path='/decisiontemplateresults/:partnerId/:partnerScenarioId' component={DecisionTemplateResults} />
                            <PrivateRoute path='/alternative/:partnerId/:partnerScenarioId/:partnerAlternativeId' component={AlternativeSettings} />
                            {/* <PrivateRoute path='/metric/:partnerScenarioId/:partnerMetricId' component={MetricSettings} /> */}
                            {/* <PrivateRoute path='/objective/:partnerId/:partnerScenarioId/:partnerObjectiveId' component={CriteriaSettings} /> */}
                            <PrivateRoute path='/participant/:partnerId/:partnerScenarioId/:participantId' component={ParticipantSettings} />
                            <PrivateRoute path='/sysadmin' component={SystemAdmin} />
                            <Route path='/logout' component={Logout}></Route>
                        </div>
                        {/* <AppFooter /> */}
                    </div>
                    {/* </MuiPickersUtilsProvider> */}
                </div>
                <ToastContainer />
            </Fragment>
        );
    }
}

export default Main;